import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../components/toast/ErrorToast";


export default class ListAuthorizationsFeature {

    constructor(application, navigator) {
        this._application = application;
        this._navigate = navigator;
        this._loaded = false;
        this._authorizations = [];

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
        })
    }

    async load() {
        await this.allAuthorizations()
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    columnsContent() {
        return [
            {id: 'requester', label: 'Usuario'},
            {id: 'action', label: 'Tipo de autorizacion'},
            {id: 'requestTimestamp', label: 'Fecha'},
            {id: 'authorizator', label: 'Autorizador'},
            {id: 'state', label: 'Estado'},
            {id: 'responseTimestamp', label: 'Fecha cambio de estado'},
        ];
    }

    presentedAuthorizations() {
        return this._authorizations.map((authorization) => {
            return this._presentedAuthorizations(authorization);
        });
    }

    _presentedAuthorizations(authorization) {
        return {
            id: authorization.id,
            requestTimestamp: authorization.actionRequest.timestamp,
            action: authorization.actionRequest.name,
            requester: authorization.actionRequest.requester,
            state: authorization.state,
            responseTimestamp: authorization.responseTimestamp,
            authorizator: authorization.authorizator
        }
    }

    async allAuthorizations() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._authorizations = response.authorizations();
            },
            handlesError: (response) => {
                errorToast('No se pudieron obtener las autorizaciones')
            }
        });
        return this._application.apiClient().allAuthorizations(responseHandler)
    }

    authorizationScreenUrl(row){
        return (`/authorization/${row.id}`)
    }
}